import { AsyncPipe } from '@angular/common';
import {
  AfterViewChecked,
  AfterViewInit,
  Component,
  ElementRef,
  inject,
  Inject,
  signal,
  ViewChild,
  WritableSignal,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TuiTextfield, TuiButton, TuiError, TuiIcon } from '@taiga-ui/core';
import { TuiFieldErrorPipe } from '@taiga-ui/kit';
import { TuiInputModule } from '@taiga-ui/legacy';
import { Subscription, switchMap, tap } from 'rxjs';
import {
  DemandeContact,
  DemandeContactList,
} from '../../models/demandeContact';
import { Patient } from '../../models/patient';
import { DemandeContactService } from '../../services/demande-contact.service';
import { PatientService } from '../../services/patient.service';
import { DemandeContactListComponent } from '../demande-contact-list/demande-contact-list.component';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-demande-contact-modal',
  standalone: true,
  imports: [
    TuiTextfield,
    TuiButton,
    TuiError,
    TuiFieldErrorPipe,
    AsyncPipe,
    TuiInputModule,
    ReactiveFormsModule,
    TuiIcon,
    DemandeContactListComponent,
  ],
  templateUrl: './demande-contact-modal.component.html',
  styleUrl: './demande-contact-modal.component.scss',
})
export class DemandeContactModalComponent
  implements AfterViewInit, AfterViewChecked
{
  demandeContactForm: FormGroup;
  public demandesContactList0: WritableSignal<DemandeContact[]> = signal([]);

  constructor(@Inject('patient') public patient: Patient | undefined) {
    this.demandeContactForm = this.formBuilder.group({
      objet: [''],
      message: ['', [Validators.required]],
      pdf: [null],
    });
  }
  private shouldScroll = true;

  @ViewChild('messageContainer') private messageContainer!: ElementRef;

  commonService = inject(CommonService);
  demandeContactService = inject(DemandeContactService);
  patientService = inject(PatientService);
  formBuilder = inject(FormBuilder);

  enCoursDeChargement0: WritableSignal<boolean> = signal(false);

  onSubmit() {
    if (this.demandeContactForm.valid) {
      let newDemandeContact: DemandeContact = new DemandeContact(-1, '', '');
      newDemandeContact.objet =
        this.demandeContactForm.value.objet &&
        this.demandeContactForm.value.objet != ''
          ? this.demandeContactForm.value.objet
          : 'Sans objet';
      newDemandeContact.message = this.demandeContactForm.value.message;
      newDemandeContact.patient = this.patient;
      newDemandeContact.pdf = this.demandeContactForm.value.pdf;

      console.log(newDemandeContact);

      this.demandeContactForm.reset();

      let temp: DemandeContact[] = this.demandesContactList0();
      temp.push(newDemandeContact);
      this.demandesContactList0.set(temp);
      this.shouldScroll = true;

      this.demandeContactService.push(newDemandeContact).subscribe({
        next: (data) => {
          this.updateDemandesContactList();
          this.commonService.showSuccessAlert('Message reçu !');
        },
        error: (err) => {
          this.updateDemandesContactList();
          this.commonService.showErrorAlert(
            "Erreur lors de l'envoi du message !",
          );
        },
      });
    }
  }

  updateDemandesContactList() {
    this.enCoursDeChargement0.set(true);
    if (this.patient) {
      this.patientService.pullDemandeContactList(this.patient!).subscribe({
        next: (temp: DemandeContactList) => {
          this.demandesContactList0.set(temp.data);
          this.shouldScroll = true;
          this.enCoursDeChargement0.set(false);
        },
        error: (err) => {
          this.demandesContactList0.set([]);
          this.shouldScroll = true;
          this.enCoursDeChargement0.set(false);
        },
      });
    } else {
      this.demandeContactService.pull().subscribe({
        next: (temp: DemandeContactList) => {
          this.demandesContactList0.set(temp.data);
          this.shouldScroll = true;
          this.enCoursDeChargement0.set(false);
        },
        error: (err) => {
          this.demandesContactList0.set([]);
          this.shouldScroll = true;
          this.enCoursDeChargement0.set(false);
        },
      });
    }
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const reader = new FileReader();

      reader.onload = () => {
        // Récupère le contenu en base64
        const base64String = reader.result as string;
        // Extrait uniquement la partie base64 (sans le préfixe "data:...")
        const base64Data = base64String.split(',')[1];

        // Envoie les données à l'API
        this.demandeContactForm.get('pdf')?.setValue(base64Data);
      };

      reader.readAsDataURL(file);
    }
  }

  ngOnInit(): void {
    this.updateDemandesContactList();
  }

  private scrollToBottom(): void {
    try {
      this.messageContainer.nativeElement.scrollTop =
        this.messageContainer.nativeElement.scrollHeight;
    } catch (err) {
      //
    }
  }

  ngAfterViewInit() {
    this.scrollToBottom();
  }

  ngAfterViewChecked() {
    if (this.shouldScroll) {
      this.scrollToBottom();
      this.shouldScroll = false; // Évite les boucles infinies
    }
  }
}
